import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Content, { HTMLContent } from '../components/Content'
import styled from '@emotion/styled';
import { darkThemeColors, fonts } from '../util/styles';
import logo from '../img/logo_blue.jpg'
import { Image } from "semantic-ui-react";
import Container from "../components/Footer";


export const ContactPageTemplate = ({ image, title, content, contentComponent }) => {

  return (
    <section className="section section--gradient">
      <div className="container">
        <div className="columns">
          <div className="column is-10 is-offset-1">
            <div className="section">
              <Heading >
                <Image src={logo} style={{ width: '5em', height: '5em',  display: 'block',
                  marginLeft: 'auto',
                  marginRight: 'auto'}}/>
                Contact Us
              </Heading>
              <h3>GMGT Live Inc is located in Brooklyn New York. We are a media Production and Broadcast company dedicated to the promotion and growth of caribbean culture worldwide. GMGT is Where The Culture Lives.</h3>
              <SemiTransparentBackground>
                <br/>
                <h4>Phone Numbers</h4>
                Main:  <a href="tel:+1-518-497-4151">+1-518-497-4151</a>
                <br/>
                Whatsapp:  <a href="https://wa.me/13473095254">1-347-309-5254</a>

                <br/>
                <h4>Email</h4>
                Questions: <p><a href="mailto:info@gmgt.live">info@gmgt.live</a></p>
                Got Music: <p><a href="mailto:music@gmgt.live">music@gmgt.live</a></p>
                Store Help:<p><a href="mailto:sales@gmgt.live">sales@gmgt.live</a></p>
              </SemiTransparentBackground>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}


const Heading = styled(`div`)`
  color: ${darkThemeColors.brandDark};
  padding: 3vmin;
  font: ${fonts.monospace};
  font-size: calc(28px + 0.5vh + 1.5vw);
  line-height: calc(1.1em + 0.5vw);
  background: -webkit-linear-gradient(${darkThemeColors.brandDark}, ${darkThemeColors.brandDark});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const SemiTransparentBackground = styled(`div`)`
  color: ${"black"};
  padding: 3vmin;
`;

ContactPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  content: PropTypes.string,
  contentComponent: PropTypes.func,
}

const ContactPage = ({ data }) => {
  const { markdownRemark: post } = data

  return (
    <ContactPageTemplate
      image={post.frontmatter.image}
      contentComponent={HTMLContent}
      title={post.frontmatter.title}
      content={post.html}
    />
  )
}

ContactPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default ContactPage

export const contactPageQuery = graphql`
  query ContactPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
      }
    }
  }
`
